import React from 'react';
import PropTypes from 'prop-types';
import loader from '../../assets/images/loader.svg';

const CircularProgress = ({ className }) => (
  <div className={`loader ${className}`}>
    <img alt="loader" src={loader} />
  </div>
);

CircularProgress.propTypes = {
  className: PropTypes.string
};

CircularProgress.defaultProps = {
  className: ''
};

export default CircularProgress;
